import { Injectable } from "@angular/core";
import { ParentService } from "../../pages/A2-utils/ParentClass/ParentService";
import { Http, Response } from "@angular/http";
import { constant } from "../../app.constants";
import { Observable } from "rxjs/Observable";
import { IUberPayload } from "../enums/uber.enum";

@Injectable()
export class UberService extends ParentService {
  constructor(private _http: Http) {
    super();
  }

  sendToUber(tripId: number, payload: IUberPayload): Observable<any> {
    return this._http
      .post(`${constant.URL_SEND_TO_UBER}/${tripId}`, payload, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  cancelSendToUber(tripId: number): Observable<any> {
    return this._http
      .delete(
        `${constant.URL_CANCEL_SEND_TO_UBER}/${tripId}`,
        this.headerPost()
      )
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  getIsSentToUber(tripId: number): Observable<boolean> {
    return this._http
      .get(`${constant.URL_VERIFY_TO_UBER}/${tripId}`, this.getHeader())
      .map((res) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/uber.service.ts